require("core-js/features/array/find-index");

import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"
import { mapState } from "vuex";
import { INewContractState, IContractSettings } from "../../new-contract-vuex-store";
import { ICompanyViewModel, IContractViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import Authentication from "./authentication.vue";
import { SectionChecker } from "../../Default/common/section";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue";
import ValidationMessage from "../../Default/common/validation-message.vue";
import { ContractContactPersonTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";

class Checker extends SectionChecker {
    constructor() {
        super();
        this.properties = [
            (contract: IContractViewModel) => contract.Company.BusinessId,
            (contract: IContractViewModel) => contract.Company.CompanyName,
            (contract: IContractViewModel) => contract.Company.Phone,
            (contract: IContractViewModel) => contract.Company.Email,
            (contract: IContractViewModel) => { return contract.Company.ContactPersons.length > 0 ? contract.Company.ContactPersons[0].FirstName : null },
            (contract: IContractViewModel) => { return contract.Company.ContactPersons.length > 0 ? contract.Company.ContactPersons[0].LastName : null },
            (contract: IContractViewModel) => { return contract.Company.ContactPersons.length > 0 ? contract.Company.ContactPersons[0].Phone : null },
            (contract: IContractViewModel) => { return contract.Company.ContactPersons.length > 0 ? contract.Company.ContactPersons[0].Email : null },
            (contract: IContractViewModel) => { return contract.Company.ContactPersons.length > 0 ? contract.Company.ContactPersons[0].ContactPersonRole : null }
        ];
        this.validationIds = ["BusinessId", "CompanyName", "Phone", "Email", "LastName__contactperson-1", "FirstName__contactperson-1", "Phone__contactperson-1", "Email__contactperson-1"];
    }
}

export let CompanyInformationChecker = new Checker();

@Component({
    components: {
        ValidatedFormGroup,
        ValidationMessage,
        Authentication
    },
    computed: mapState({
        contract: (state: INewContractState) => state.contract,
        company: (state: INewContractState) => state.contract.Company,
        contactPersonFirstName: (state: INewContractState) =>
            state.contract.Company.ContactPersons != null && state.contract.Company.ContactPersons.length != 0
                ? state.contract.Company.ContactPersons[0].FirstName
                : null,
        contactPersonLastName: (state: INewContractState) =>
            state.contract.Company.ContactPersons != null && state.contract.Company.ContactPersons.length != 0
                ? state.contract.Company.ContactPersons[0].LastName
                : null,
        contactPersonPhone: (state: INewContractState) =>
            state.contract.Company.ContactPersons != null && state.contract.Company.ContactPersons.length != 0
                ? state.contract.Company.ContactPersons[0].Phone
                : null,
        contactPersonEmail: (state: INewContractState) =>
            state.contract.Company.ContactPersons != null && state.contract.Company.ContactPersons.length != 0
                ? state.contract.Company.ContactPersons[0].Email
                : null,
        contactPersonRole: (state: INewContractState) =>
            state.contract.Company.ContactPersons != null && state.contract.Company.ContactPersons.length != 0
                ? state.contract.Company.ContactPersons[0].ContactPersonRole
                : null,
    })
})

export default class CompanyInformation extends Vue {
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get company(): ICompanyViewModel { return this.$store.state.contract.Company; }
    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get offerRequest(): boolean { return this.$store.state.offerRequest; }
    get strongContractAuthentication(): boolean { return this.contract.StrongContractAuthentication }

    @Prop()
    public validationErrors: any;

    @Prop()
    public showAuthentication: boolean;

    @Emit()
    companyValueUpdated(allSet: boolean) { }

    @Emit()
    authenticate() { }

    constructor() {
        super();
    }

    valueUpdated() {
        let c: ICompanyViewModel = this.company;
        let cp = c.ContactPersons[0];
        let values = [
            c.CompanyName,
            c.BusinessId,
            cp != null ? cp.FirstName : null,
            cp != null ? cp.LastName : null,
            c.Phone,
            c.Email
        ];

        let ndx = values.findIndex(x => x == null || x.toString().length == 0)
        this.companyValueUpdated(ndx == -1);
        //let allSet = CompanyInformationChecker.isAllSet(this.contract);
        //this.companyValueUpdated(allSet);
    }

}